import React from 'react'
import DownloadNameCards from '../../Components/nameCard/DownloadNameCards'

export default function DownloadNameCard() {
  return (
    <div><DownloadNameCards/></div>
  )
}
